import { getEnv } from '@skype/bew-helpers/dist/getEnv';
import { getStaticHost } from '@skype/bew-helpers/dist/getStaticHost';
import { LazyResourceLoader } from '@skype/bew-helpers/dist/LazyResourceLoader';
import { normalizeLocale } from '@skype/bew-helpers/dist/normalizeLocale';
import { shouldRenderUhf } from '@skype/bew-helpers/dist/shouldRenderUhf';
import { Promise } from 'es6-promise';

// Polyfills for < IE11 - http://fb.me/react-polyfills
import 'core-js/es6/map';
import 'core-js/es6/set';
import 'raf/polyfill';

enum UhfHosts {
    //PRE  = 'uhf-ppe.microsoft.com',
    PRE  = 'uhf.microsoft.com',
    QA   = 'uhf.microsoft.com',
    LIVE = 'uhf.microsoft.com'
}

declare type EnvName = keyof typeof UhfHosts;
declare const window: any;

if (!window.SKYPE) {
    window.SKYPE = {};
}

interface UhfConfig {
    authToken?: string;
    className?: string;
    language?:  string;
}

window.SKYPE.Uhf = {
    init: (conf: UhfConfig) : boolean => {
        if (conf.className) {
            bodyClassName = conf.className;
        }

        if (!shouldRenderUhf()) {
            showBody();
            return true;
        }

        Promise
            .all([
                LazyResourceLoader.loadScript(getStaticHost() + '/cdn/common/react@16/umd/react.production.min.js', false),
                LazyResourceLoader.loadScript(getStaticHost() + '/cdn/common/react-dom@16/umd/react-dom.production.min.js', false)
            ])
            .then(() => {
                require('./Uhf.tsx').render({
                    authToken: conf.authToken,
                    callback:  showBody,
                    locale:    normalizeLocale(conf.language),
                    domain:    UhfHosts[getEnv().toUpperCase() as EnvName]
                });
            })
            .catch((e: any) => {
                console.error(e);
                showBody();
            });

        return true;
    }
};

// Deliberately not using "classList.remove()" here - not supported below IE10
const showBody = () => document.body.className = document.body.className.replace(bodyClassName, '');
let bodyClassName = 'uhfized';
